import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { DistributorUserListScreen } from '../features/distributor-users/DistributorUserListScreen'

/** /distributor-users — управление сотрудниками дистрибьютора (S41). */
export const Route = createFileRoute('/distributor-users')({
  component: DistributorUsersRoute,
})

function DistributorUsersRoute() {
  return (
    <RequireAuth>
      <DistributorUserListScreen />
    </RequireAuth>
  )
}
